export default "__VITE_ASSET__B3682ZUT__"